import { memo } from 'react';

import Login from '../../components/templates/Login';

const LoginPage = memo(() => (
  <div className='app-container'>
    <div className='loginContainer'>
      <Login />
    </div>
  </div>
));

LoginPage.getInitialProps = async (ctx) => {
  if (ctx.isServer) {
    const state = ctx.store.getState();
    const my_profile = state.my_profile;

    if (my_profile.data) {
      if (!ctx.res._headerSent) {
        ctx.res.writeHead(302, { Location: '/jobs/explore' });
        ctx.res.end();
      }
    }
  }

  return { isServer: ctx.isServer };
};

LoginPage.displayName = 'LoginPage';

export default LoginPage;
